import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CompleteMembershipFragment = { __typename?: 'Membership', id: string, type: string, accountUser?: { __typename?: 'AccountUser', accountUserType?: Types.AccountUserTypeEnum | null, avatarColor?: Types.AvatarColor | null, email?: string | null, id: string, inviteEmailAddress?: string | null, isPending: boolean, name?: string | null, profileImageUrl?: string | null, userId?: string | null, licenseType?: Types.AccountUserLicenseTypeValue | null } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', accountId: string, emoji?: string | null, id: string, memberCount?: number | null, name?: string | null } | null, role?: { __typename?: 'Role', description?: string | null, id: string, name: string, order?: number | null } | null };

export const CompleteMembership = /*#__PURE__*/ gql`
    fragment CompleteMembership on Membership {
  accountUser {
    accountUserType
    avatarColor
    email
    id
    inviteEmailAddress
    isPending
    name
    profileImageUrl
    userId
    licenseType
  }
  accountUserGroup {
    accountId
    emoji
    id
    memberCount
    name
  }
  id
  role {
    description(locale: $locale)
    id
    name(locale: $locale)
    order
  }
  type
}
    ` as unknown as DocumentNode<CompleteMembershipFragment, unknown>;

        

        
export const useCompleteMembershipFragment = (
  input: string | Omit<UseFragmentOptions<CompleteMembershipFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Membership' } };
    return input;
  })();

  return useFragment<CompleteMembershipFragment>({
    fragment: CompleteMembership,
    fragmentName: 'CompleteMembership',
    ...options,
  });
};
  
        